import React from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Translate from '../../../../i18n/Translate/Translate';
import SanitizedReactHtmlParser from '../../../../utils/helpers/SanitizedReactHtmlParser';

const WizardMenuItem = ({
  path, isComplete, name, nextStep, disabled, search, nameIsHtml,
}) => (
  <NavLink
    id={`wizard-item-${name}`}
    to={{ pathname: path, search }}
    onClick={(e) => {
      if (disabled) {
        e.preventDefault();
      }
    }}
    className={classNames('wizard-menu-item__link', {
      'wizard-menu-item__link_passed': isComplete,
      'wizard-menu-item__link_next': path.endsWith(`/${nextStep}`),
      'wizard-menu-item__link_disabled': disabled,
    })}
    activeClassName="wizard-menu-item__link_active"
  >
    <span className="wizard-menu-item__title">
      <span className="d-none d-lg-inline text-capitalize">
        {nameIsHtml ? SanitizedReactHtmlParser(name) : <Translate translationKey={name} />}
      </span>
    </span>
  </NavLink>
);

WizardMenuItem.defaultProps = {
  nextStep: '',
  disabled: false,
  search: '',
  nameIsHtml: false,
};

WizardMenuItem.propTypes = {
  nextStep: PropTypes.string,
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isComplete: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  search: PropTypes.string,
  nameIsHtml: PropTypes.bool,
};

export default WizardMenuItem;
